var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import JetFormSection from "@/Jetstream/FormSection";
import JetSectionBorder from '@/Jetstream/SectionBorder';
import { usePage } from "@inertiajs/react";
export default function Billing(_a) {
    var team = _a.team;
    var page = usePage();
    return _jsx("div", { children: _jsxs("div", { children: [_jsx(JetSectionBorder, {}), _jsx("div", __assign({ className: "mt-10 sm:mt-0" }, { children: _jsx(JetFormSection, __assign({ title: 'Billing', description: '', onSubmit: function () { } }, { children: _jsxs("div", __assign({ className: "col-span-6 lg:col-span-4 space-y-6" }, { children: [page.props.baseTeam.credits_remaining_count > 0 && _jsxs("div", __assign({ className: "border p-4" }, { children: [_jsx("strong", { children: page.props.baseTeam.credits_remaining_count }), _jsx("span", { children: "\u00A0" }), "credits remaining"] })), _jsxs("div", __assign({ className: "border p-4" }, { children: ["Subscription credits used this billing period: ", team.credits_used_in_billing_period] }))] })) })) }))] }) });
}
